import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { setMobileHotelFilterAction } from 'src/routes/SearchPage/actions/filters';
import { isMobileHotelFilterOpenedSelector } from 'src/routes/SearchPage/selectors/filtersBase';
import MobileHotelFilter from './MobileHotelFilter';

const mapStateToProps = (state) => ({
  isFilterOpened: isMobileHotelFilterOpenedSelector(state),
});

const mapDispatchToProps = {
  setFilterOpened: setMobileHotelFilterAction,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(MobileHotelFilter);
